<template>
    <div class="loading-outer">
        <div class="capper">
            <div class="loading-dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoadingComponent",
    props: {},
    data () {
        return {
            window: window,
        }
    },
    mounted() {

    }
}
</script>